import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const userCustomerApi = {
  getAll: (params) => {
    const url = "customers";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },
  createUser: (params) => {
    const url = "customers";
    const payload = CheckNullParams(params);

    return axiosClient.post(url, payload);
  },
  updateUser: (id, params) => {
    const url = "customers/";
    const payload = CheckNullParams(params);
    return axiosClient.patch(url + id, payload);
  },
  deleteUser: (id) => {
    const url = "customers/";
    return axiosClient.delete(url + id);
  },
  deleteUsers: (params) => {
    const url = "customers";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
  resetPassword: (id) => {
    const url = "users/resetPassword/";
    return axiosClient.get(url + id);
  },
  changePassword: (data) => {
    const url = "auth/change-password";
    return axiosClient.post(url, data);
  },
  getAdress: (params) => {
    const url = "/addresses";
    return axiosClient.get(url, {
      params: params,
    });
  },
};

export default userCustomerApi;
